export enum DataCodeEnum {
  WHAT_IS_ZODIAC = "WHAT_IS_ZODIAC",
  ZODIAC_SIGN_THEIR_ELEMENTS = "ZODIAC_SIGN_THEIR_ELEMENTS",
  WHAT_HOUSE_IN_YOUR_BIRTH_CHART_MEAN = "WHAT_HOUSE_IN_YOUR_BIRTH_CHART_MEAN",

  WHAT_IS_NUMEROLOGY = "WHAT_IS_NUMEROLOGY",
  THE_MEANING_OF_LIFE_PATH_NUMBER_AND_DESTINY_NUMBER = "THE_MEANING_OF_LIFE_PATH_NUMBER_AND_DESTINY_NUMBER",
  MEANING_OF_NUMBERS_INTRODUCTION = "MEANING_OF_NUMBERS_INTRODUCTION",
  MEANING_OF_NUMBERS_1 = "MEANING_OF_NUMBERS_1",
  MEANING_OF_NUMBERS_2 = "MEANING_OF_NUMBERS_2",
  MEANING_OF_NUMBERS_3 = "MEANING_OF_NUMBERS_3",
  MEANING_OF_NUMBERS_4 = "MEANING_OF_NUMBERS_4",
  MEANING_OF_NUMBERS_5 = "MEANING_OF_NUMBERS_5",
  MEANING_OF_NUMBERS_6 = "MEANING_OF_NUMBERS_6",
  MEANING_OF_NUMBERS_7 = "MEANING_OF_NUMBERS_7",
  MEANING_OF_NUMBERS_8 = "MEANING_OF_NUMBERS_8",
  MEANING_OF_NUMBERS_9 = "MEANING_OF_NUMBERS_9",
  WHAT_ARE_ANGEL_NUMBERS = "WHAT_ARE_ANGEL_NUMBERS",
  MASTER_NUMBERS = "MASTER_NUMBERS",
  NUMEROLOGY_INDICATORS_LIFE_PATH_HOW_TO_CALCULATE = "NUMEROLOGY_INDICATORS_LIFE_PATH_HOW_TO_CALCULATE",
  NUMEROLOGY_INDICATORS_LIFE_PATH = "NUMEROLOGY_INDICATORS_LIFE_PATH",
  NUMEROLOGY_INDICATORS_EXPRESSION_HOW_TO_CALCULATE = "NUMEROLOGY_INDICATORS_EXPRESSION_HOW_TO_CALCULATE",
  NUMEROLOGY_INDICATORS_EXPRESSION = "NUMEROLOGY_INDICATORS_EXPRESSION",
  NUMEROLOGY_INDICATORS_BIRTHDAY = "NUMEROLOGY_INDICATORS_BIRTHDAY",
  NUMEROLOGY_INDICATORS_NAME = "NUMEROLOGY_INDICATORS_NAME",
  NUMEROLOGY_INDICATORS_COMPATIBILITY = "NUMEROLOGY_INDICATORS_COMPATIBILITY",
  WHAT_IS_TAROT = "WHAT_IS_TAROT",

  DAILY_CARD = "DAILY_CARD",
  DAILY_LOVE_TAROT_DECK = "DAILY_LOVE_TAROT_DECK",
  ONE_CARD_TAROT_DECK = "ONE_CARD_TAROT_DECK",
  YES_NOT_TAROT_CARD = "YES_NOT_TAROT_CARD",
}

export enum ZodiacEnum {
  Aries = "Aries",
  Taurus = "Taurus",
  Gemini = "Gemini",
  Cancer = "Cancer",
  Leo = "Leo",
  Virgo = "Virgo",
  Libra = "Libra",
  Scorpio = "Scorpio",
  Sagittarius = "Sagittarius",
  Capricorn = "Capricorn",
  Aquarius = "Aquarius",
  Pisces = "Pisces",
}

export const ZodiacOptions = Object.values(ZodiacEnum);
